import { Trash } from "@phosphor-icons/react";

export default function BulkDeleteModal({ count, deleting, onCancel, onConfirm }) {
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={() => !deleting && onCancel()}
    >
      <div
        className="glass max-w-md w-full p-6 md:p-8"
        onClick={(e) => e.stopPropagation()}
        data-testid="bulk-delete-modal"
      >
        <div className="flex items-start gap-4 mb-5">
          <div className="border border-[#E60000] bg-red-50 p-2">
            <Trash size={22} weight="bold" className="text-[#E60000]" />
          </div>
          <div className="flex-1">
            <div className="overline text-[#E60000] mb-1">CONFIRMAR EXCLUSÃO</div>
            <h2 className="font-head text-2xl font-black tracking-tighter">Excluir {count} pedido{count > 1 ? "s" : ""}?</h2>
          </div>
        </div>
        <p className="text-sm text-zinc-600 mb-2">
          Esta ação é <span className="font-bold">irreversível</span>. Os pedidos selecionados serão removidos permanentemente do sistema.
        </p>
        <p className="text-xs text-zinc-500 mb-6">
          Atenção: pedidos sincronizados do Bling poderão voltar na próxima sincronização caso ainda existam no ERP.
        </p>
        <div className="flex gap-3">
          <button
            className="btn btn-ghost flex-1"
            onClick={onCancel}
            disabled={deleting}
            data-testid="cancel-bulk-delete"
          >
            Cancelar
          </button>
          <button
            className="btn flex-1"
            style={{ background: "#E60000", color: "white", borderColor: "#E60000" }}
            onClick={onConfirm}
            disabled={deleting}
            data-testid="confirm-bulk-delete"
          >
            <Trash size={16} weight="bold" />
            {deleting ? "Excluindo..." : "Confirmar Exclusão"}
          </button>
        </div>
      </div>
    </div>
  );
}
